<template>
  <div>
    <div class="nav-profile">
      <div class="nav-profile active" @click="next(0)"></div>
      <div class="nav-profile" @click="next(1)"></div>
      <div class="nav-profile" @click="next(2)"></div>
    </div>
    <div class="limiter-profile profile-menu">
      <div class="container-profile">
        <div class="wrap-login">
            <div class="login-form validate-form">
                <p class="txt1 warning" style="color: #4caf50; margin-bottom:1em;" v-if="msg">{{ msg }}</p>

                <span class="login-form-title">
                    Welcome : <p>{{ this.$store.getters.getUser.mail }}</p>
                </span>

                <div class="wrap-input validate-input" data-validate="Enter key">
                    <span class="btn-show-pass">
                        <i class="zmdi zmdi-eye"></i>
                    </span>
                    <input class="input" type="password" name="pass" id="encryptionKey" :value="this.$store.getters.getKey">
                    <span class="focus-input" data-placeholder="Encryption Key"></span>
                </div>

                <div class="container-login-form-btn">
                  <div class="wrap-login-form-btn">
                    <button class="login-form-btn" @click="decrypt" value="Login"> Decrypt all </button>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="container-profile">
        <div class="wrap-login">
            <div class="login-form validate-form">
                <p class="txt1 warning" style="color: #4caf50; margin-bottom:1em;" v-if="msg">{{ msg }}</p>

                <span class="login-form-title">
                  <p>Do you want to change your encryption key ?</p>
                </span>

                <div class="wrap-input validate-input" data-validate="Enter key">
                  <span class="btn-show-pass">
                    <i class="zmdi zmdi-eye"></i>
                  </span>
                  <input class="input" type="password" name="pass" id="encryptionKeyReset" :value="this.$store.getters.getKey">
                  <span class="focus-input" data-placeholder="Ancient Encryption Key"></span>
                </div>

                <div class="wrap-input validate-input" data-validate="Enter key">
                  <span class="btn-show-pass">
                    <i class="zmdi zmdi-eye"></i>
                  </span>
                  <input class="input" type="password" name="pass" id="encryptionKeyResetNew" :value="''">
                  <span class="focus-input" data-placeholder="New Encryption Key"></span>
                </div>

                <div class="container-login-form-btn">
                  <div class="wrap-login-form-btn">
                    <button class="login-form-btn" @click="reset" value="Login"> Update </button>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="container-profile">
        <div class="wrap-login">
          <div class="login-form validate-form">
            <p class="txt1 warning" style="color: #4caf50; margin-bottom:1em;" v-if="msg">{{ msg }}</p>

            <span class="login-form-title">
              <p>Do you want to set up a double authentification ?</p>
            </span>

            <span class="login-form-auth">
              <div @click="changeAuth(1)">Yes</div>
              /
              <div @click="changeAuth(0)">No</div>
            </span>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript" src="../assets/js/login.js"></script>

<script>
import AuthService from '@/services/AuthService.js'
import ApplicationService from '@/services/ApplicationService.js'

export default {
  data () {
    return {
      msg: '',
      nav: 0,
      applications: []
    }
  },
  mounted () {
    $('.input').each(function(){
        $(this).on('blur', function(){
            if($(this).val().trim() != "") {
                $(this).addClass('has-val');
            }
            else {
                $(this).removeClass('has-val');
            }
        })
    })

    var input = $('.validate-input .input');

    if(this.$store.getters.getKey) {
      $(input[0]).addClass('has-val')
      $(input[1]).addClass('has-val')
    }

    $('.validate-form').on('submit',function(){
        var check = true;

        for(var i=0; i<input.length; i++) {
            if(validate(input[i]) == false){
                showValidate(input[i]);
                check=false;
            }
        }

        return check;
    });

    $('.validate-form .input').each(function(){
        $(this).focus(function(){
           hideValidate(this);
        });
    });

    function showValidate(input) {
        var thisAlert = $(input).parent();

        $(thisAlert).addClass('alert-validate');
    }

    function hideValidate(input) {
        var thisAlert = $(input).parent();

        $(thisAlert).removeClass('alert-validate');
    }

    if(this.$store.getters.getUser.double_authentification)
      this.changeAuth(this.$store.getters.getUser.double_authentification)

    var showPass = 0;
    $('.btn-show-pass').on('click', function(){
      if(showPass == 0)
      {
          $(this).next('input').attr('type','text');
          $(this).find('i').removeClass('zmdi-eye');
          $(this).find('i').addClass('zmdi-eye-off');
          showPass = 1;
      }
      else
      {
          $(this).next('input').attr('type','password');
          $(this).find('i').addClass('zmdi-eye');
          $(this).find('i').removeClass('zmdi-eye-off');
          showPass = 0;
      }
    });
  },
  methods: {
    decrypt () {
      this.key = $('#encryptionKey')[0].value
      this.msg = 'Your key has been updated !'

      this.$store.dispatch('crypt', this.key)

      setTimeout( () => {
        this.msg = ''
      }, 3000)
    },
    next(direction) {
      document.querySelector('.limiter-profile').style.transform = `translateX(${-direction*100}vw)`
      this.nav = direction
      for(let nav of document.querySelector('.nav-profile').children)
        $(nav).removeClass('active')
      $(event.target).addClass('active')
    },
    async reset() {
      let ancientKey = $('#encryptionKeyReset')[0].value
      let newKey = $('#encryptionKeyResetNew')[0].value
      try {
        const credentials = { user: this.$store.getters.getUser }
        let applicationsEncrypted = await ApplicationService.getApplications(credentials)
        for(let application of applicationsEncrypted) {
          const credentials = { application: ApplicationService.encryptContent(newKey, ApplicationService.decryptContent(ancientKey, application)) }
          let res = await ApplicationService.updateApplication(credentials)
        }
        this.$store.dispatch('crypt', newKey)
      } catch (error) {
        this.msg = error
      }
    },
    changeAuth(answer) {
      let container = $('.login-form-auth').children()
      if(answer == 1) {
        $(container[0]).addClass('activate')
        $(container[1]).removeClass('activate')
      } else {
        $(container[1]).addClass('activate')
        $(container[0]).removeClass('activate')
      }
    }
  }
}
</script>

<style lang="scss">

.login-form-auth {
  display: block;
  font-family: "Poppins";
  color: #333333;
  line-height: 1.2;
  text-align: center;
  padding-bottom: 60px;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  > div {
    font-size: 30px;
    font-weight: bold;
    cursor: pointer;
  }

  > .activate {
    color: #4caf50;
  }

  > * {
    margin: 0 0.5em;
  }
}

.profile-menu {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  transition: transform 0.5s ease;
}

.container-profile {
  width: 100vw;
  min-height: 90vh;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: #efeeee;
}

.limiter-profile {
  width: 300vw;
  margin: 0 auto;
}

.nav-profile {
  position: fixed;
  height: auto;
  width: 100vw;
  left: 0;
  bottom: 13vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 10;

  div {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: transparent;
    margin: 0 1em;
    position: initial;
    border: 1px solid #4caf50;
    cursor: pointer;
  }

  .active {
    background-color: #4caf50;
  }
}

#login {
  p {
    color: #919191;

    span {
      color: #1d1d1d;
      cursor: pointer;
      font-weight: bold;
    }
  }

  input {
    border: none;
    border-bottom: 2px solid #919191;
    outline: none;
    color: #919191;
    width: 70%;
  }
}

#login > * {
  margin: 1em;
}

.button__green {
  background-color: rgb(76, 176, 80);
  padding: 0.5em 2em;
  border: solid 2px white;
  border-radius: 20px;
  color: white !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: none !important;
}

.zmdi-eye {
  background-size: 18px;
  background-image: url('../assets/eye.svg');
}
.zmdi-eye-off {
  background-size: 18px;
  background-image: url('../assets/hide.svg');
  transform: scale(0.9);
}
</style>
